var pt_br = {
    values: {
        'Registrar atividade': 'Registrar atividade',
        'Editar registro de atividade': 'Editar registro de atividade',
        Registros: 'Registros',
        Qualifier: 'Qualificador',
        'Default Mnemonic': 'Mnemônico padrão',
        'Default Unit': 'Unidade padrão',
        'must not be empty': 'é obrigatório',
        Apply: 'Aplicar',
        Add: 'Adicionar',
        'add line': 'Adicionar linha',
        copy: 'cópia',
        'Well name': 'Nome do poço',
        'Include extra fields': 'Incluir campos adicionais',
        'Begin date': 'Data inicial',
        'End date': 'Data final',
        'The end time must be selected when choosing an end date':
            'A hora precisa ser definida quando há uma data final selecionada',
        optional: 'opcional',
        Hour: 'Hora',
        Intervention: 'Intervenção',
        Choose: 'Escolha',
        'Detailing 1': 'Detalhamento 1',
        'Detailing 2': 'Detalhamento 2',
        Classification: 'Classificação',
        'Additional information': 'Informações adicionais',
        Save: 'Salvar',
        Cancel: 'Cancelar',
        'Client Role': 'Função do Cliente',
        'Basic information': 'Informações básicas',
        'Value generation estimate': 'Estimativa de geração de valor',
        'Safety/Conformity': 'Segurança/Conformidade',
        'Performance/Financial': 'Performance/Financeiro',
        'Tags (opcional, crie com vírgula ou [enter])': 'Tags (opcional, crie com vírgula ou [enter])',
        'Posto CSD': 'Posto CSD',
        Comments: 'Comentários',
        'Latest from SITOP': 'Mais recente do SITOP',
        'Please choose an intervention': 'Selecione uma intervenção',
        "There's no SITOP data for the": 'Não existem dados no SITOP para o',
        'selected day': 'dia selecionado',
        'Are you sure you want to fill this report with the latest SITOP data?':
            'Tem certeza que deseja preencher este relatório com os dados mais recentes do SITOP?',
        'SITOP data was empty': 'Nenhum dado do SITOP',
        'Error while fetching SITOP data': 'Um erro ocorreu ao buscar dados do SITOP',
        csdContacts: 'Contatos do CSD',
        csd: 'CSD',
        'Channels normalization': 'Normalização de canais',
        'Leak-off test': 'LOT',
        'Pore pressure': 'PP',
        'Riser safety margin': 'MSR',
        'CREATE STAGE': 'CRIAR STAGE',
        Activity: 'Processo',
        'Service Nature': 'Encaminhamento',
        'undefined error': 'erro não definido',
        'Activity Log': 'Registros de Atividades',
        drilling: 'Perfuração',
        Completion: 'Completação',
        evaluation: 'Avaliação',
        workover: 'Workover',
        abandonment: 'Abandono',
        not_specified: 'Não especificado',
        'Create Operation Comments': 'Criar comentários de operação',
        'Create Activity Log': 'Criar registro de atividades',
        'Performance Gain': 'Ganho em Performance',
        'SMS Gain': 'Ganho em SMS'
    }
}

module.exports = pt_br
